import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import EntryField from "./EntryField";
import {
  TRACK_OPTICS_INJURY_ENTRY_FRONT_LIMBS_ID,
  IField,
  IWorkoutAnalysisFormState,
  mapFormFields,
  TRACK_OPTICS_INJURY_ENTRY_NONE_ID,
  TRACK_OPTICS_INJURY_ENTRY_REAR_LIMBS_ID,
  WorkoutAnalysisFormField
} from "../helpers";

interface IProps {
  workoutAnalysisFormState: IWorkoutAnalysisFormState;
  onChangeField: (key: WorkoutAnalysisFormField, id: string) => void;
  data: Partial<
    Omit<racehorse360.PullTrackOpticsVideoConditionsResponse, "toJSON">
  >;
}

const InjuryFields = (props: IProps) => {
  const { data, workoutAnalysisFormState, onChangeField } = props;

  const checkFieldsToRender = (key: WorkoutAnalysisFormField) => {
    switch (key) {
      case WorkoutAnalysisFormField.INJURY_ENTRY_ID:
        return true;
      case WorkoutAnalysisFormField.LIMB_ID:
        return [
          TRACK_OPTICS_INJURY_ENTRY_FRONT_LIMBS_ID,
          TRACK_OPTICS_INJURY_ENTRY_REAR_LIMBS_ID
        ].includes(workoutAnalysisFormState.injuryEntryId);
      case WorkoutAnalysisFormField.STRIDE_ID:
        return (
          workoutAnalysisFormState.limbId !== "" ||
          workoutAnalysisFormState.injuryEntryId ===
            TRACK_OPTICS_INJURY_ENTRY_NONE_ID
        );
      default:
        return false;
    }
  };

  const fields: IField[] = [
    {
      key: WorkoutAnalysisFormField.INJURY_ENTRY_ID,
      label: "Injury Entry",
      entries: mapFormFields(data.trackOpticsVideoInjuryEntries),
      value: workoutAnalysisFormState.injuryEntryId,
      shouldRender: checkFieldsToRender(
        WorkoutAnalysisFormField.INJURY_ENTRY_ID
      )
    },
    {
      key: WorkoutAnalysisFormField.LIMB_ID,
      label: "Limb",
      entries: mapFormFields(data.trackOpticsVideoLimbs),
      value: workoutAnalysisFormState.limbId,
      shouldRender: checkFieldsToRender(WorkoutAnalysisFormField.LIMB_ID)
    },
    {
      key: WorkoutAnalysisFormField.STRIDE_ID,
      label: "Stride",
      entries: mapFormFields(data.trackOpticsVideoStrides),
      value: workoutAnalysisFormState.strideId,
      shouldRender: checkFieldsToRender(WorkoutAnalysisFormField.STRIDE_ID)
    }
  ];

  return fields.map(
    field =>
      field.shouldRender && (
        <EntryField
          key={field.key}
          field={field}
          currentActiveId={workoutAnalysisFormState[field.key]}
          onEntryButtonClick={onChangeField}
        />
      )
  );
};

export default React.memo(InjuryFields);
